/**
 * Central constants for the holiday packages module.
 *
 * Every route, endpoint and limit the module depends on lives here, so this
 * is the one file to audit when the module is copied to another client.
 */

export const PACKAGE_ROUTES = {
  // Search lives on the main landing page as the "Packages" tab.
  LANDING: '/?searchtype=packages',
  RESULTS: '/packages/results',
  DETAILS: '/packages/details',
  BOOKING: '/packages/booking',
  BOOKING_DETAILS: '/packages/booking-details/:pkgBookingId',
};

export const bookingDetailsRoute = (pkgBookingId) =>
  PACKAGE_ROUTES.BOOKING_DETAILS.replace(
    ':pkgBookingId',
    encodeURIComponent(pkgBookingId),
  );

/**
 * Packages REST service: POST {origin}/api/nextra/packages/v1/{operation}
 * with a JSON body and the agent's session token in the `authtoken` header.
 * The origin is taken from the app's main API URL (see packagesApi.js).
 */
export const PACKAGE_API = {
  BASE_PATH: 'api/nextra/packages/v1/',
  OPS: {
    FACETS: 'available-facets',
    SEARCH: 'search',
    DETAIL: 'detail',
    QUOTE: 'quote',
    BOOK: 'book',
    BOOKING_DETAILS: 'booking-details',
    ENQUIRE: 'enquire',
    TRANSACTIONS: 'transactions',
  },
};

/** Ages each passenger type must fall in (whole years). */
export const PACKAGE_AGE_LIMITS = {
  ADULT: { min: 12, max: 120 },
  CHILD: { min: 2, max: 11 },
  INFANT: { min: 0, max: 1 },
};

export const PACKAGE_LIMITS = {
  MAX_PAX: 12,
  MIN_DAYS: 1,
  MAX_DAYS: 30,
  MAX_REQUESTS: 500,
};

export const ADULT_TITLE_OPTIONS = [
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
];

export const CHILD_TITLE_OPTIONS = [
  { value: 'Mstr', label: 'Mstr' },
  { value: 'Miss', label: 'Miss' },
];

/** Payment modes, as on the eSIM / visa booking pages (values are what the backend expects). */
export const WALLET_MODE = 'cashcard';

export const PAYMENT_MODES = [
  { key: WALLET_MODE, label: 'Wallet' },
  { key: 'creditcard', label: 'Credit Card' },
  { key: 'debitcard', label: 'Debit Card' },
  { key: 'netbanking', label: 'Net Banking' },
  { key: 'upi', label: 'UPI' },
];

export const paymentModeLabel = (mode) =>
  PAYMENT_MODES.find((m) => m.key === mode)?.label || mode || '';

export const PACKAGE_SORT_TABS = [
  { key: 'price', label: 'Price Low to High' },
  { key: 'priceDesc', label: 'Price High to Low' },
  { key: 'duration', label: 'Shortest Trip' },
  { key: 'departure', label: 'Soonest Departure' },
];
